var _defs, _rect, _g, _g2, _path, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkingWithComputer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1700.79 1133.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #3c3c3b;\n      }\n\n      .cls-3 {\n        mask: url(#mask);\n      }\n\n      .cls-4 {\n        filter: url(#luminosity-noclip);\n      }\n\n      .cls-5 {\n        fill: #1e2859;\n      }\n\n      .cls-6 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4);\n      }\n\n      .cls-7 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_7);\n      }\n\n      .cls-8 {\n        fill: #367ad1;\n      }\n\n      .cls-9 {\n        fill: #a0d9f2;\n      }\n\n      .cls-10 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_7-2);\n      }\n\n      .cls-11 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4-3);\n      }\n\n      .cls-12 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4-2);\n      }\n\n      .cls-13 {\n        mask: url(#mask-1);\n      }\n\n      .cls-14 {\n        fill: #e8988c;\n      }\n\n      .cls-15 {\n        fill: #575756;\n      }\n\n      .cls-16 {\n        fill: #fff;\n      }\n\n      .cls-17 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_92-2);\n      }\n\n      .cls-18 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_30-2);\n      }\n\n      .cls-19 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_30-3);\n      }\n\n      .cls-20 {\n        fill: #ff9b2b;\n      }\n\n      .cls-21 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_8);\n        mix-blend-mode: multiply;\n      }\n\n      .cls-22 {\n        fill: #ffafa3;\n      }\n\n      .cls-23 {\n        fill: #30358c;\n      }\n\n      .cls-24 {\n        opacity: .85;\n      }\n\n      .cls-25 {\n        fill: #e68922;\n      }\n\n      .cls-26 {\n        fill: #ffb35c;\n      }\n\n      .cls-27 {\n        fill: #e87f79;\n      }\n\n      .cls-28 {\n        fill: #9d9d9c;\n      }\n\n      .cls-29 {\n        fill: #333332;\n      }\n\n      .cls-30 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_30);\n      }\n\n      .cls-31 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_24);\n      }\n\n      .cls-32 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_13);\n      }\n\n      .cls-33 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_92);\n      }\n\n      .cls-34 {\n        fill: #ededed;\n      }\n\n      .cls-35 {\n        fill: #fec1b5;\n      }\n\n      .cls-36 {\n        fill: #dadada;\n      }\n\n      .cls-37 {\n        fill: #c8e9f7;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_30",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 30",
    x1: 1515.96,
    y1: 609.07,
    x2: 217.09,
    y2: 781.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76ebd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8e9f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_30-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 30",
    x1: 1486.32,
    y1: 385.42,
    x2: 187.46,
    y2: 557.56,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_30-3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 30",
    x1: 1493.63,
    y1: 440.5,
    x2: 194.75,
    y2: 612.64,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 697.5,
    y1: 733.25,
    x2: 423.98,
    y2: 259.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30358c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367ad1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_92",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 92",
    x1: 261.62,
    y1: 496.37,
    x2: 808.57,
    y2: 496.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ac9eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#76c4e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#6bb8e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#59a3de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#4186d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367ad1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 665.02,
    y1: 721.41,
    x2: 405.17,
    y2: 271.34,
    gradientTransform: "translate(507.71 -232.98) rotate(45)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 299.25,
    y: 246.86,
    width: 290.78,
    height: 249.52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 299.25,
    y: -8758.96,
    width: 290.78,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 299.25,
    y: -8758.96,
    width: 290.78,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_8",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 8",
    x1: 606.04,
    y1: 307.45,
    x2: 342.57,
    y2: 484.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 299.25,
    y: 246.86,
    width: 290.78,
    height: 249.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M554.79,472.78l35.25-222.52c-13.43-2.24-27.21-3.4-41.27-3.4-137.8,0-249.51,111.71-249.51,249.51h0s249.51,0,249.51,0l6.02-23.6Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_24",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 24",
    x1: 606.04,
    y1: 307.45,
    x2: 342.57,
    y2: 484.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76ebd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4-3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 735.53,
    y1: 717.39,
    x2: 735.53,
    y2: 334.83,
    gradientTransform: "translate(445.53 0) skewX(-5.4)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_92-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 92",
    x1: 334.66,
    y1: 286.86,
    x2: 641.85,
    y2: 818.93,
    gradientTransform: "translate(445.53 0) skewX(-5.4)",
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_92"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_13",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 13",
    x1: 820.24,
    y1: 744.98,
    x2: 721.1,
    y2: 437.13,
    gradientTransform: "translate(445.53 0) skewX(-5.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30358c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#30378e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3254ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3469c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3575cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367ad1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_7",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 7",
    x1: 512.33,
    y1: 832.92,
    x2: 643.3,
    y2: 606.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec7b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa9c55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_7-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 7",
    x1: 1390.7,
    y1: 827.66,
    x2: 1554.41,
    y2: 544.11,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 1700.79,
    height: 1133.86
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1452.31,617.28c-15.91-82.3-104.39-134.41-197.64-116.39-93.25,18.02-155.94,99.35-140.03,181.66,6.96,35.99,27.79,66.2,56.83,87.3h211.52c51.72-35.03,80.73-93.55,69.32-152.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M975.55,396.97c-38.76-101.96-138.53-166.6-257.24-180.22-48.44-33.35-107.13-52.88-170.39-52.88-154.99,0-282.61,117.22-299.03,267.84,30.91-133.27,150.38-232.58,293.05-232.58,34.03,0,66.74,5.66,97.25,16.07-43.37,3.14-87.92,12.78-131.9,29.5-118.16,44.92-205.48,130.76-243.82,226.56-45.33,11.27-69.01,85.75-53.01,168.53,16.3,84.31,67.59,145.29,114.56,136.21,2.54-.49,5.02-1.19,7.43-2.06,94.1,80.68,247.37,103.76,394.25,47.93,198.03-75.28,309.45-265.51,248.86-424.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M810.65,221.96c86.11,27.07,155.87,82.24,191.48,161.09,70.13,155.27-16.14,349.14-194.34,457.39,197.11-103.67,298.98-302.96,228.85-458.22-38.95-86.23-123.16-141.63-225.99-160.26Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 560.74,
    cy: 496.37,
    r: 273.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 535.09,
    cy: 496.37,
    r: 273.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 535.09,
    cy: 496.37,
    r: 259.8,
    transform: "translate(-194.26 523.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M794.9,496.37c0,141.2-112.64,256.09-252.97,259.71-140.33-3.62-252.97-118.51-252.97-259.71s112.64-256.09,252.97-259.71c140.33,3.62,252.97,118.51,252.97,259.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M794.9,496.37c0,63.87-23.05,122.35-61.28,167.59-45.65,50.32-111.56,81.92-184.85,81.92-127.97,0-233.43-96.33-247.83-220.43,8.22,17.93,18.84,35.18,31.92,51.28,79.33,97.65,218.77,115.77,311.46,40.47,92.69-75.3,103.51-215.5,24.18-313.15-15.53-19.11-33.36-35.18-52.7-48.1,46.01,12.8,86.66,38.45,117.85,72.84,38.21,45.23,61.25,103.71,61.25,167.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M554.79,472.78l35.25-222.52c-13.43-2.24-27.21-3.4-41.27-3.4-137.8,0-249.51,111.71-249.51,249.51h0s249.51,0,249.51,0l6.02-23.6Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 356.51,
    y: 492.52,
    width: 192.26,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 475.26,
    y: 403.35,
    width: 176.44,
    height: 12.08,
    transform: "translate(65.86 896.71) rotate(-80.4)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 309.4,
    y: 492.79,
    width: 29.72,
    height: 7.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 339.48,
    y: 380.54,
    width: 29.72,
    height: 7.16,
    transform: "translate(239.53 -125.71) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 421.66,
    y: 298.36,
    width: 29.72,
    height: 7.16,
    transform: "translate(479.75 -227.06) rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 533.91,
    y: 268.28,
    width: 29.72,
    height: 7.16,
    transform: "translate(820.63 -276.9) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 758.42,
    y: 492.79,
    width: 29.72,
    height: 7.16,
    transform: "translate(1546.55 992.75) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 728.34,
    y: 380.54,
    width: 29.72,
    height: 7.16,
    transform: "translate(1578.88 345.18) rotate(150)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 646.16,
    y: 298.36,
    width: 29.72,
    height: 7.16,
    transform: "translate(1253.02 -119.54) rotate(120)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 339.48,
    y: 605.04,
    width: 29.72,
    height: 7.16,
    transform: "translate(-256.84 258.71) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 421.66,
    y: 687.22,
    width: 29.72,
    height: 7.16,
    transform: "translate(-379.99 723.44) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 533.91,
    y: 717.3,
    width: 29.72,
    height: 7.16,
    transform: "translate(-172.11 1269.65) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 728.34,
    y: 605.04,
    width: 29.72,
    height: 7.16,
    transform: "translate(1082.51 1507.31) rotate(-150)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 646.16,
    y: 687.22,
    width: 29.72,
    height: 7.16,
    transform: "translate(393.28 1608.66) rotate(-120)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1335.95,769.85c0,4.92-243.31,8.91-543.44,8.91s-543.44-3.99-543.44-8.91,243.31-8.91,543.44-8.91,543.44,3.99,543.44,8.91Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M828.76,665.82c28.73,0,49.81,23.29,47.09,52.01-2.72,28.73-28.21,52.01-56.93,52.01h-26.56l9.84-104.02h26.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M745.26,717.84c-2.72,28.73,18.36,52.01,47.09,52.01s54.22-23.29,56.93-52.01c2.72-28.73-18.36-52.01-47.09-52.01s-54.22,23.29-56.93,52.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M763.99,717.84c-1.74,18.38,11.75,33.29,30.14,33.29s34.7-14.9,36.44-33.29c1.74-18.38-11.75-33.29-30.14-33.29s-34.7,14.9-36.44,33.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1219.09,665.82c28.73,0,49.81,23.29,47.09,52.01-2.72,28.73-28.21,52.01-56.93,52.01h-26.56l9.84-104.02h26.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1135.59,717.84c-2.72,28.73,18.36,52.01,47.09,52.01s54.22-23.29,56.93-52.01c2.72-28.73-18.36-52.01-47.09-52.01s-54.22,23.29-56.93,52.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1154.32,717.84c-1.74,18.38,11.75,33.29,30.14,33.29s34.7-14.9,36.44-33.29c1.74-18.38-11.75-33.29-30.14-33.29s-34.7,14.9-36.44,33.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1133.79,665.82c28.73,0,49.81,23.29,47.09,52.01-2.72,28.73-28.21,52.01-56.93,52.01h-26.56l9.84-104.02h26.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M743.46,665.82c28.73,0,49.81,23.29,47.09,52.01-2.72,28.73-28.21,52.01-56.93,52.01h-26.56l9.84-104.02h26.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1311.7,588.28c-4.76-6.04-8.18-13.07-10.09-20.68l-53-212c-3.11-12.43-14.02-20.77-27.16-20.77h-276.93l-36.2,382.56h394.97c8.17,0,15.42-6.62,16.19-14.79l7.72-81.58c.71-7.5-1.34-14.75-5.77-20.38l-9.72-12.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1209.56,600.64l-9.72-12.35c-4.76-6.04-8.18-13.07-10.09-20.68l-53-212c-3.11-12.43-14.02-20.77-27.16-20.77h-436.61c-14.72,0-28.02,11.35-30.51,26.03l-31.34,185.33-13.28,140.29c-.97,10.27,6.17,18.8,16.35,19.52l161.05,11.39h416.18c8.17,0,15.42-6.62,16.19-14.79l7.72-81.58c.71-7.5-1.34-14.75-5.77-20.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M649.62,708.51l.75-7.89c3.3-34.92,34.29-63.23,69.22-63.23s60.56,28.31,57.25,63.23l-1.59,16.78-125.63-8.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1039.11,717.39l1.59-16.78c3.3-34.92,34.29-63.23,69.22-63.23s60.56,28.31,57.25,63.23l-1.59,16.78h-126.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1167.17,700.61l-1.59,16.77h-63.24s4.88-51.57,4.88-51.57h26.57c12.1,0,22.84,4.13,31.02,11.06,2.28,7.33,3.15,15.34,2.36,23.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1154.32,717.84c-2.72,28.73-28.21,52.01-56.93,52.01s-49.81-23.29-47.09-52.01c2.72-28.73,28.21-52.01,56.93-52.01s49.81,23.29,47.09,52.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1135.59,717.84c-1.74,18.38-18.05,33.29-36.44,33.29s-31.88-14.9-30.14-33.29c1.74-18.38,18.05-33.29,36.44-33.29s31.88,14.9,30.14,33.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1117.93,699.6c.38,2.63.37,5.4-.11,8.27-2.18,13.14-13.68,23.79-26.91,24.89-2.7.23-5.3.06-7.73-.45-2.1-.44-3.81,2.09-2.49,3.71,4.44,5.42,11.25,8.81,19.18,8.78,14.86-.06,28.14-12.34,29.43-27.19.7-8.1-2.25-15.35-7.5-20.25-1.53-1.43-4.17.11-3.86,2.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1193.33 692.31 1208.59 692.31 1210.05 676.79 1194.8 676.79 1193.33 692.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1063.52,576.61h-35.01l.89-9.39h35.01l-.89,9.39ZM1030.43,574.87h31.51l.56-5.91h-31.51l-.56,5.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1164.37,625.8h-53.27v-1.74h53.27c2.96,0,5.6-2.41,5.88-5.37l4.07-43.02,1.73.16-4.07,43.02c-.36,3.83-3.78,6.95-7.61,6.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1034.97,687.17h-224.32v-1.74h222.96c8.95-34.47,42.85-61.37,77.49-61.37v1.74c-34.09,0-67.46,26.67-75.97,60.71l-.16.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M810.65,687.17h-25.51l-.05-.82c-2.06-33.95-30.31-60.55-64.33-60.55-22.94,0-49.51,16.46-59.02,31.24l-.26.4h-60.81v-1.74h59.86c5.17-7.83,14.4-15.72,25.39-21.71,11.76-6.4,24.13-9.93,34.83-9.93,17.21,0,33.49,6.58,45.84,18.51,11.84,11.45,18.99,26.64,20.17,42.86h23.88v1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1026.08,518.69l12.28-129.79c.45-4.76,4.68-8.63,9.44-8.63h78.26c3.77,0,6.87,2.45,7.66,6.05l38.45,175.66c1.36,6.22-4.61,12.28-10.9,11.05l-111.26-21.66c-15.4-3-25.45-16.72-23.94-32.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M776.84,700.61l-1.59,16.77h-63.24s4.88-51.57,4.88-51.57h26.57c12.1,0,22.84,4.13,31.02,11.06,2.28,7.33,3.15,15.34,2.36,23.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M763.99,717.84c-2.72,28.73-28.21,52.01-56.93,52.01s-49.81-23.29-47.09-52.01c2.72-28.73,28.21-52.01,56.93-52.01s49.81,23.29,47.09,52.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M745.26,717.84c-1.74,18.38-18.05,33.29-36.44,33.29s-31.88-14.9-30.14-33.29c1.74-18.38,18.05-33.29,36.44-33.29s31.88,14.9,30.14,33.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M727.59,699.6c.38,2.63.37,5.4-.11,8.27-2.18,13.14-13.68,23.79-26.91,24.89-2.7.23-5.3.06-7.73-.45-2.1-.44-3.81,2.09-2.49,3.71,4.44,5.42,11.25,8.81,19.18,8.78,14.86-.06,28.14-12.34,29.43-27.19.7-8.1-2.25-15.35-7.5-20.25-1.53-1.43-4.17.11-3.86,2.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1293.52 573.19 1200.48 573.19 1152.24 380.27 1245.29 380.27 1293.52 573.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "1226.85 692.31 1208.59 692.31 1210.05 676.79 1228.32 676.79 1226.85 692.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1320.45 692.31 1302.18 692.31 1303.65 676.79 1321.92 676.79 1320.45 692.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1323.83,656.56h-14.57c-2.04,0-3.54-1.66-3.35-3.7l2.1-22.2c.38-4.06,1.04-8.12,1.95-12.14l2.85-12.53c.7-3.06,3.52-5.35,6.62-5.35h1.99c4.44,5.63,6.49,12.88,5.78,20.38l-3.36,35.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 861.2,
    y: 532.41,
    width: 307.4,
    height: 1.74,
    transform: "translate(388.41 1493.45) rotate(-84.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 637.55,
    y: 379.4,
    width: 619.41,
    height: 1.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1172.81,
    y: 561.81,
    width: 1.74,
    height: 14.09,
    transform: "translate(-94.5 264.16) rotate(-12.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1198.87,605.12l.74,6.09c.52,4.29.58,8.67.16,13.06l-2.71,28.6c-.19,2.04,1.31,3.7,3.35,3.7h11.55l3.36-35.55c.71-7.5-1.34-14.75-5.78-20.38h-6.65c-2.36,0-4.32,2.18-4.04,4.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1305.56 656.56 1230.24 656.56 1233.26 624.56 1308.59 624.56 1305.56 656.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1228.66,616.77l-7-11.85c-1.58-2.68-4.48-4.28-7.73-4.28h-4.37c4.43,5.63,6.48,12.88,5.77,20.38l-3.36,35.55h14.57c2.04,0,3.85-1.66,4.05-3.7l1.78-18.85c.58-6.16-.71-12.17-3.71-17.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M611.83,534.79l-.71,11.4-10.44,110.37h22.15l10.94-115.61c.32-3.4-2.18-6.16-5.58-6.16h-16.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "616.68 604.51 605.61 604.51 600.68 656.56 611.76 656.56 616.68 604.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M628.62,604.6l-1.73-.16,6.01-63.56c.13-1.4-.29-2.72-1.18-3.7-.89-.97-2.14-1.51-3.53-1.51h-16.36v-1.74h16.36c1.89,0,3.6.74,4.82,2.08,1.23,1.35,1.8,3.14,1.62,5.03l-6.01,63.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1274.85,573.19h-74.37l-38.95-155.77h72.88c3.77,0,6.87,2.45,7.66,6.04l32.78,149.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1161.28,573.03l-25.69-5c-1.14-3.79-1.56-7.91-1.16-12.2l10.99-116.11,26.76,122.25c1.36,6.23-4.61,12.28-10.9,11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1162.92,574.06c-.6,0-1.21-.06-1.81-.17l-111.26-21.66.33-1.71,111.26,21.66c2.68.52,5.51-.42,7.56-2.52,2.03-2.07,2.89-4.88,2.32-7.49l-38.45-175.66c-.7-3.21-3.44-5.36-6.81-5.36v-1.74c4.21,0,7.63,2.7,8.51,6.73l38.45,175.66c.7,3.19-.34,6.59-2.77,9.08-2.01,2.06-4.66,3.19-7.33,3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1293.52,574.06h-84.26c-5.66,0-10.37-3.6-11.71-8.97l-46.16-184.62,1.69-.42,46.16,184.62c1.14,4.58,5.17,7.65,10.02,7.65h84.26v1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1133.17,575.74h13.88c2.04,0,3.85-1.66,4.05-3.7l4.7-49.66c.19-2.04-1.31-3.7-3.35-3.7h-13.88c-2.04,0-3.85,1.66-4.05,3.7l-4.7,49.66c-.19,2.04,1.31,3.7,3.35,3.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M847.45,432.28l23.98-4.69c.81-.16,1.55.51,1.46,1.34l-.75,7.26c-.06.54-.46.98-.99,1.08l-14.76,2.89c-.53.1-.93.54-.99,1.08l-1.28,12.33c-.09.82.65,1.5,1.46,1.34l8.83-1.73c.81-.16,1.55.51,1.46,1.34l-.75,7.26c-.06.54-.46.98-.99,1.08l-10.31,2.02c-.53.1-.93.54-.99,1.08l-2.38,22.91c-.06.54-.46.98-.99,1.08l-7.42,1.45c-.81.16-1.55-.51-1.46-1.34l5.88-56.71c.06-.54.46-.98.99-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M886.67,424.66l11.04-2.16c.73-.14,1.41.38,1.47,1.12l3.81,54.77c.04.62-.38,1.18-.99,1.3l-7.92,1.55c-.73.14-1.43-.39-1.47-1.14l-.55-10.15c-.04-.75-.73-1.29-1.47-1.14l-6.37,1.25c-.47.09-.84.44-.96.9l-3.18,12.31c-.12.46-.49.81-.96.9l-7.69,1.5c-.89.18-1.66-.65-1.43-1.53l15.71-58.59c.12-.45.49-.8.95-.89ZM887.86,459.99l2.58-.5c.6-.12,1.02-.65.99-1.26l-.36-8.66c-.06-1.43-2.09-1.63-2.43-.24l-2.21,9.16c-.21.87.55,1.67,1.43,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M924.13,475.72c-2.03,0-3.79-.43-5.24-1.28-1.87-1.06-3.28-2.76-4.19-5.03-.9-2.24-1.28-4.95-1.15-8.06l.02-.35,9.54-2.52v.62c.03,3.17.65,5.36,1.84,6.5.62.61,1.32.91,2.14.91.3,0,.61-.04.94-.12,1.84-.42,3.42-1.61,4.7-3.55.65-.95,1.06-2.24,1.23-3.82.23-2.26-.56-4.26-2.43-6.11-.03-.03-.07-.07-.11-.1-1.57-1.27-3.95-3.2-7.11-5.76-2.72-2.27-4.62-4.46-5.65-6.51-1.11-2.33-1.5-5.04-1.19-8.06.56-5.4,2.87-9.92,6.87-13.43,2.47-2.13,5.44-3.55,8.83-4.21,1.29-.25,2.52-.38,3.64-.38,1.73,0,3.29.3,4.63.9,1.75.78,3.12,2.1,4.05,3.93.92,1.8,1.37,4.01,1.32,6.58v.33s-9.7,3.56-9.7,3.56v-.69c0-2.2-.47-3.83-1.39-4.85-.43-.48-1.04-.71-1.87-.71-.33,0-.7.04-1.09.12-1.52.3-2.72,1.17-3.66,2.66-.77,1.21-1.25,2.65-1.42,4.27-.26,2.51.6,4.89,2.55,7.08.75.85,1.92,1.81,3.51,2.86,1.95,1.32,3.2,2.24,3.82,2.82,2.01,1.76,3.55,3.62,4.56,5.54.48.9.85,1.75,1.12,2.54.66,1.97.92,3.82.77,5.51-.36,4.12-1.85,7.92-4.4,11.29-1.69,2.28-3.97,4.13-6.77,5.49-1.5.73-3.24,1.29-5.16,1.66-1.27.25-2.47.37-3.56.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M965.7,418.83l-6.27,1.23c-.81.16-1.55-.51-1.46-1.34l.75-7.27c.06-.54.46-.98.99-1.08l26.44-5.17c.81-.16,1.55.51,1.46,1.34l-.75,7.26c-.06.54-.46.98-.99,1.08l-7.7,1.51c-.53.1-.93.54-.99,1.08l-4.94,47.59c-.06.54-.46.98-.99,1.08l-7.42,1.45c-.81.16-1.55-.51-1.46-1.34l4.78-46.09c.09-.82-.65-1.5-1.46-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M690.08,544.7c.06-.54.46-.98.99-1.08l13.54-2.65c1.04-.2,2.05-.31,2.99-.31,2.73,0,5.08.86,6.98,2.56,2.56,2.29,3.65,5.46,3.24,9.41l-3.16,30.44c-.41,3.93-2.18,7.61-5.27,10.94-3.09,3.32-6.67,5.4-10.65,6.18l-13.09,2.56c-.81.16-1.55-.51-1.46-1.34l5.88-56.71ZM695.15,589.78c-.09.82.65,1.5,1.46,1.34l3.14-.61c1.31-.26,2.49-.95,3.5-2.07,1.01-1.12,1.59-2.32,1.72-3.57l3.16-30.49c.13-1.24-.19-2.18-.97-2.88-.58-.52-1.26-.77-2.09-.77-.29,0-.6.03-.92.09l-4.16.81c-.53.1-.93.54-.99,1.08l-3.84,37.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M732.13,535.59l23.98-4.69c.81-.16,1.55.51,1.46,1.34l-.75,7.26c-.06.54-.46.98-.99,1.08l-14.76,2.89c-.53.1-.93.54-.99,1.08l-1.28,12.33c-.09.82.65,1.5,1.46,1.34l8.83-1.73c.81-.16,1.55.51,1.46,1.34l-.75,7.26c-.06.54-.46.98-.99,1.08l-10.3,2.02c-.53.1-.93.54-.99,1.08l-1.28,12.33c-.09.82.65,1.5,1.46,1.34l13.29-2.6c.81-.16,1.55.51,1.46,1.34l-.75,7.26c-.06.54-.46.98-.99,1.08l-23.98,4.69c-.81.16-1.55-.51-1.46-1.34l5.88-56.71c.06-.54.46-.98.99-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M768.82,528.46l7.42-1.45c.81-.16,1.55.51,1.46,1.34l-4.79,46.18c-.09.82.65,1.5,1.46,1.34l12.2-2.39c.81-.16,1.55.51,1.46,1.34l-.74,7.17c-.06.54-.46.98-.99,1.08l-22.89,4.48c-.81.16-1.55-.51-1.46-1.34l5.88-56.67c.06-.54.46-.98.99-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M804.43,521.5l7.42-1.45c.81-.16,1.55.51,1.46,1.34l-5.88,56.67c-.06.54-.46.98-.99,1.08l-7.42,1.45c-.81.16-1.55-.51-1.46-1.34l5.88-56.67c.06-.54.46-.98.99-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M826.01,517.27l7.89-1.54c.73-.14,1.42.39,1.47,1.13l2.03,32.41c.09,1.4,2.07,1.59,2.42.23l9.41-36.06c.12-.46.49-.81.96-.9l7.74-1.51c.9-.18,1.67.66,1.42,1.54l-16.41,58.73c-.13.45-.49.79-.95.88l-11.05,2.16c-.72.14-1.41-.38-1.46-1.11l-4.46-54.64c-.05-.63.38-1.19.99-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M872.18,508.2l23.98-4.69c.81-.16,1.55.51,1.46,1.34l-.75,7.26c-.06.54-.46.98-.99,1.08l-14.76,2.89c-.53.1-.93.54-.99,1.08l-1.28,12.33c-.09.82.65,1.5,1.46,1.34l8.83-1.73c.81-.16,1.55.51,1.46,1.34l-.75,7.27c-.06.54-.46.98-.99,1.08l-10.31,2.02c-.53.1-.93.54-.99,1.08l-1.28,12.33c-.09.82.65,1.5,1.46,1.34l13.29-2.6c.81-.16,1.55.51,1.46,1.34l-.75,7.26c-.06.54-.46.98-.99,1.08l-23.98,4.69c-.81.16-1.55-.51-1.46-1.34l5.88-56.71c.06-.54.46-.98.99-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M907.88,502.15c.06-.54.46-.98.99-1.08l13.59-2.66c1.54-.3,2.97-.45,4.24-.45,2.98,0,5.27.84,6.79,2.49,1.9,2.05,2.63,5.29,2.18,9.62l-.88,8.46c-.41,3.97-2.23,7.69-5.41,11.06-.27.28-.39.67-.33,1.05l3.74,22.55c.11.66-.32,1.28-.98,1.41l-8.21,1.61c-.69.13-1.35-.33-1.46-1.02l-2.77-18.33c-.1-.69-.77-1.16-1.46-1.03l-2.98.58c-.53.1-.93.54-.99,1.08l-2.09,20.12c-.06.54-.46.98-.99,1.08l-7.42,1.45c-.81.16-1.55-.51-1.46-1.34l5.88-56.67ZM915.23,525.25c-.09.82.65,1.5,1.46,1.34l3.14-.61c1.31-.26,2.5-.95,3.52-2.05,1.02-1.1,1.61-2.31,1.74-3.59l.88-8.5c.15-1.4-.05-2.41-.58-3-.43-.47-1.08-.7-2-.7-.43,0-.91.05-1.45.16l-4.16.81c-.53.1-.93.54-.99,1.08l-1.56,15.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M953.63,525.66l-8.19-30.45c-.19-.69.25-1.39.95-1.53l8.36-1.64c.65-.13,1.29.29,1.44.94l3.08,13.51c.27,1.18,1.9,1.31,2.35.18l6.58-16.67c.15-.39.5-.68.91-.76l8.11-1.59c.97-.19,1.76.79,1.37,1.7l-14.9,34.69c-.05.11-.08.24-.09.36l-2.45,23.58c-.06.54-.46.98-.99,1.08l-7.42,1.45c-.81.16-1.55-.51-1.46-1.34l2.39-23.07c.02-.15,0-.3-.04-.45Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1233.26,
    y: 623.69,
    width: 75.33,
    height: 1.74
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M489.5,853.96c0,3.57,26.54,6.47,59.27,6.47s59.27-2.9,59.27-6.47-26.54-6.47-59.27-6.47-59.27,2.9-59.27,6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M509.97,803.25c-7.73-8.97-12.44-20.63-12.44-33.4,0-28.3,22.94-51.23,51.23-51.23s51.23,22.94,51.23,51.23c0,12.77-4.7,24.43-12.44,33.4l-38.8,50.71-38.79-50.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 548.77,
    cy: 769.85,
    r: 29.51,
    transform: "translate(-162.2 146.68) rotate(-13.28)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1436.24,
    cy: 853.96,
    rx: 74.09,
    ry: 8.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1387.75,790.57c-9.67-11.22-15.55-25.78-15.55-41.75,0-35.37,28.67-64.04,64.04-64.04s64.04,28.67,64.04,64.04c0,15.96-5.88,30.53-15.55,41.75l-48.49,63.39-48.49-63.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 1436.24,
    cy: 748.82,
    r: 36.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 548.77,
    cy: 893.81,
    r: 18.96,
    transform: "translate(-471.29 649.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 1436.24,
    cy: 893.81,
    r: 18.96,
    transform: "translate(427.01 2251.44) rotate(-85.27)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "604.19 889.51 548.77 889.51 548.77 899.95 599.64 899.95 604.19 889.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "671.1 889.51 637.64 889.51 633.09 899.95 666.55 899.95 671.1 889.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1271.86,889.51c-1.66,0-4.66-.33-6.1-2.52-1.27-1.94-1.14-5,.34-8.4l17.04-39.06c2.92-6.69,2.74-13.35-.5-18.29-3.05-4.67-8.32-7.23-14.83-7.23h-57.61c-12.28,0-25.99,9.38-31.22,21.35l-44.03,100.91c-3.57,8.18-13.48,15.09-21.65,15.09h-107.18c-1.66,0-4.66-.33-6.1-2.52-1.27-1.94-1.14-5,.34-8.4l28.97-66.39c2.92-6.69,2.74-13.35-.5-18.29-3.05-4.67-8.32-7.24-14.83-7.24h-125.47c-12.28,0-25.99,9.38-31.22,21.35l-1.98,4.54c-3.57,8.18-13.48,15.09-21.65,15.09h-62.24l-4.55,10.43h66.79c12.28,0,25.99-9.38,31.22-21.35l1.98-4.54c3.57-8.18,13.48-15.09,21.65-15.09h125.47c1.66,0,4.66.33,6.1,2.52,1.27,1.94,1.14,5-.34,8.4l-28.97,66.39c-2.92,6.69-2.74,13.35.5,18.29,3.05,4.67,8.32,7.23,14.83,7.23h107.18c12.28,0,25.99-9.38,31.22-21.35l44.03-100.91c3.57-8.18,13.48-15.09,21.65-15.09h57.61c1.66,0,4.66.33,6.1,2.52,1.27,1.94,1.14,5-.34,8.4l-17.04,39.06c-2.92,6.69-2.74,13.35.5,18.29,3.05,4.67,8.32,7.23,14.83,7.23h164.38v-10.43h-164.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "738.01 889.51 704.56 889.51 700.01 899.95 733.46 899.95 738.01 889.51"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1112.69,475.99c-3.47-1.95-14.5-5.91-18.22-6.71-7.47-1.6-16.05-2.56-23.67-2.11-3.49.2-9.25.59-11.9,3.28-2.2,2.23-3.83,6.14-4.83,9.25-2.58,8.09-2.07,28.55-2.36,35.88-.27,7.03-1.37,11.26-2.52,16.55-1.16,5.34-1.98,8.84-3.2,13.99-.46,1.93-.41,3.33.28,4.29h0c1.21.39,2.46.72,3.74.97l6.81,1.33h.03c12.22,1.17,37.73,3.58,41.8,3.4,1.22-.06,3.25-.77,3.77-2.68.77-2.81-.37-16.6.92-24.48,1.3-7.95,10.33-33.25,11.95-42.97.81-4.9.92-8-2.62-9.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1067.48,536.93c-2.83-3.21-5.48-13-3.48-23.41,1.47-7.63-5-13.22-12.1-10.72-.1,5.23-.09,9.97-.2,12.77-.27,7.03-1.37,11.27-2.51,16.55-1.17,5.35-1.98,8.84-3.2,13.99-.46,1.93-.41,3.33.28,4.29,1.21.39,2.46.72,3.75.97l6.81,1.33c2.25.22,4.95.47,7.89.75,1.1-.8,2.02-1.84,2.8-3.1,4.28-6.9,2.9-10.08-.04-13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1103.06,433.65c-1.19-5.09-6.52-8.27-13.82-8.69-5.8-.33-11.09,2.91-13.1,7.29-1.92,4.18-2.47,11.08,2.49,21.52,1.19,2.49-1.18,9.67-1.59,10.78-.97,2.58-1.45,2.62-1.95,3.97-1.89,5.09,7.52,13.34,15.48,13.69,7.41.32,7.18-8.62,6.73-10.68-.36-1.63-1.75-1.89-2.51-2.4-1.26-.85-1.41-1.6-1.38-3.18.01-.32.04-.67.08-1.06.18-1.74.4-6.15,1.48-7.08.92-.8,1.37-1.08,2.4-1.89.93-.74,3.37-3.11,3.77-4.85.57-2.5.45-6.89.65-9.41.25-3.15,2.02-4.83,1.28-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1085.7,451.78c-.37-.46-2.33-3.42-2.63-3.04-.56.72.51,4.95,1.47,6.75,1.22,2.28,3.31,4.39,6.35,5.22,1.09.3,2.68.18,3.05.09.19-1.18.47-2.52,1.03-2.99.92-.78,1.38-1.08,2.39-1.9.3-.24.72-.62.94-.96-3.47,1.84-8.98,1.39-12.6-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1089.99,421.33c-6.89-.45-14.41,2.38-15.45,6.98-.39,1.73-.22,3.43-1.27,4.58-2.94,3.2-.46,9.89.5,12.4,1.32,3.46,4.53,10.65,5.7,10.17.71-.29,1.76-2.72,1.68-3.78-.15-2.27-.24-4.63-.59-6.87-.26-1.63-.23-1.64.47-2.99.26.59.87,2.32.87,2.32l2.18-1.07c1.83-2.88,2.79-7.26,2.42-11.52.34-.55,1.24-1.14,1.73-1.36,3.55-1.56,6.57-8.56,1.77-8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1081.8,443.03c.57,2.28-.09,4.44-1.47,4.82-1.38.38-2.96-1.16-3.53-3.44-.57-2.28.09-4.44,1.47-4.82,1.38-.38,2.96,1.16,3.53,3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1071.91,441.17c.2.92.97,2.63,1.97,1.42,2.81-3.42,5.17-5.54,9.22-8.09,2.61-1.64,5.04-2.99,7.98-3.57,4.03-.8,7.93-.53,11.24,1.07.55.26,1.07-.37.83-1.29-.99-3.7-2.76-6.55-7.36-9.52-3.38-2.18-10.65-1.41-14.87-.09-10.71,3.36-10.74,12.17-9,20.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1084.48,433.33c.86-.5,3.7-1.76,5.33-2.61,1.69-.88,3.07-1.82,4.64-3.05,1.36-1.06,2.48-3.03,4.78-4.31,1.37-.76,2.14-.78,2.55-.85.18-.03-.07-.27-1.21.12-2.4.81-6.1,2.89-8.35,3.63-5.88,1.93-7.97,5.6-8.28,7.17-.05.27.15.13.54-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1084.12,433.44c3.34-1.96,8.48-3.45,12.22-7.89,3.58-4.25,9.39-4.08,12.57-1.33,1.42,1.23,3.55,4.06,2.59,6.71-.86,2.38-4.73,3.72-6.85,4.01-1.03.14-1.27-.02-1.7-.52-.67-.79-1.78-2.1-3.8-2.9-2.89-1.14-8.01-.56-10.78.38-.86.29-2.94,1.31-3.83,1.82-.55.31-.9.02-.42-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1099.57,448.97c-.05.39-1.45.98-3.16.72-1.71-.26-2.79-1.58-2.64-1.93.14-.33,1.27.32,2.98.58,1.71.26,2.88.25,2.82.63Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1134.52,522.38c.19-2.04,2.01-3.7,4.05-3.7h12.12c-5.71-7.29-17.15-23.43-24.45-31.26-6.18-6.63-11.19-13.43-20.03-11.82-3.84.7-5.15,7.23-4.82,11.4.29,3.53,2,9.6,4.45,12.52,4.73,5.63,18.35,18.49,28.25,27.3l.42-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1165.09,529.58c-3.1-1.23-6.6-3.35-9.44-5.67l-1.57,16.62c4.37,1.69,8.95,2.8,13.29,3.29.28.03.57.07.86.1l-3.14-14.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1108.61,562.78l-58.59-11.41c-1.35-.26-2.66-.61-3.92-1.03.41-.39.87-.73,1.37-1.05,3.53-2.17,8.51-2.49,11.77-5.13,3.06-2.47,5.36-5.67,6.27-9.46,1.88-7.81,3.81-22.66,4.6-31.2.6-6.38,1.09-16.78-1.9-25.07-1.48-4.09-5-8.35-6.14-9.57-.76-.8-.81-1.01-.08-1.18,1.01-.24,2.91-.45,3.87-.59,1.06-.15,1.52.38,2.31,1.17,2.12,2.11,5.21,7.04,6.45,11.82,1.62,6.24,2.63,13.46,2.04,21.65,5.41.38,14.66,1.14,19.94,1.6,3.17-12.33,4.88-23.46,3.72-31.22-.18-1.22-.3-1.75.38-1.5.85.32,2.73.91,3.9,1.32,1,.35,1.26,1.9,1.39,2.36,1.57,5.9-2.11,24.31-3.56,31.81-1.19,6.18-2.61,19.89-2.88,24.91-.24,4.53-.83,9.06.49,13.55.57,1.96,2.32,5.09,3.56,6.43,2.2,2.4,4.49,2.99,4.73,5.75.08.96.2,3.34.3,6.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1032.79,538.9c1.11-10.82,8.47-41.21,10.26-49.64,1.01-4.79,2.85-14.07,8.94-17.52,2.22-1.26,6.69-2.88,7.92-3.18,1.6-.38,2.15.57,2.31.77,2.21,2.63,3.44,5.77,4.86,9.88,1.71,4.96.15,13.53-1.59,20.51-2.54,10.18-7.16,23.62-8.96,30.01-2.41,8.56,5.01,9.44,7.39,9.92,7.81,1.55,41.27,6.66,46.16,7.64,5.38,1.07,5.76,3.97,5.51,6.43-.14,1.39-2.1,2.87-4.95,2.89-8.08.04-46.65.31-59.04-.04-9.98-.28-20.54-.94-18.81-17.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1132.03,548.71c-1.54-1.24-2.98-2.38-3.8-3-.89-.68-2.41-1.57-3.64-1.56-2.57.02-5.06.22-6.67.35-1.77.15-4.02,2.3-5.97,3.55-1.99,1.27-3.54,3.94-2.01,6.49.75,1.25,2.67,1.79,4.32,1.49,2.23-.41,6.57-1.53,9.03-2.24,2.25-.65,3.8-.49,5.89.45.84.38,1.57.67,2.23.91l.61-6.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingWithComputer);
export default __webpack_public_path__ + "static/media/working_with_computer.aea11da9df2dd211930d8fdf91e96369.svg";
export { ForwardRef as ReactComponent };